const isMain = ({
  hostname,
  pathname,
}: {
  hostname: string;
  pathname: string;
}) => {
  const hostnameParts = hostname.split('.').reverse();
  const [comOrDev, stripcash] = hostnameParts;

  return (
    (comOrDev === 'com' || comOrDev === 'dev') &&
    stripcash === 'stripcash' &&
    !pathname.match(/^\/LP\w+/)
  );
};

export default isMain;
